function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 29,
  fill: "#d8d9d8",
  r: 29
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m40.4997 40c.6294 0 1.1748-.2078 1.6384-.6182l-7.9328-7.9331c-.1903.1363-.3748.2688-.5491.3949-.5936.4373-1.0755.7787-1.4454 1.0232-.37.2451-.8622.495-1.4765.7501-.6149.2554-1.1876.3827-1.7189.3827h-.0156-.0156c-.5313 0-1.1041-.1273-1.7189-.3827-.6147-.2551-1.1069-.505-1.4765-.7501-.3699-.2445-.8515-.5858-1.4454-1.0232-.1655-.1214-.3491-.2545-.5476-.397l-7.9343 7.9352c.4635.4104 1.0093.6182 1.6386.6182z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m16.5783 26.4532c-.5936-.3957-1.12-.849-1.5783-1.3595v12.0696l6.992-6.992c-1.3988-.9765-3.2011-2.2145-5.4137-3.7181z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m41.4374 26.4532c-2.1282 1.4405-3.937 2.6806-5.4266 3.7209l6.9891 6.9895v-12.0699c-.4481.5002-.9689.9532-1.5625 1.3595z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m40.4998 18h-22.9996c-.8024 0-1.4193.271-1.8515.8123-.4325.5416-.6484 1.2189-.6484 2.0312 0 .6562.2865 1.3671.8593 2.133.5728.7657 1.1822 1.367 1.8281 1.8045.3541.2501 1.4218.9924 3.2032 2.2266.9617.6664 1.798 1.2473 2.5166 1.7485.6126.4268 1.1409.7965 1.5771 1.1032.05.0351.1288.0914.2333.1662.1126.0809.2551.1835.4309.3104.3385.2449.6197.4428.8437.5939.2237.1513.4947.3202.8126.5078.3177.1873.6173.3282.8985.4219.2813.0936.5417.1406.7812.1406h.0156.0155c.2395 0 .4999-.047.7813-.1406.2811-.0937.5805-.2343.8984-.4219.3176-.1876.5883-.3569.8127-.5078.224-.1511.5052-.349.8437-.5939.1755-.1269.318-.2296.4306-.3102.1045-.075.1832-.131.2336-.1664.3398-.2364.8693-.6045 1.5812-1.0989 1.2954-.9 3.2031-2.2247 5.7313-3.9794.7603-.5311 1.3956-1.172 1.9061-1.9217.5096-.7498.7651-1.5363.7651-2.3592 0-.6876-.2477-1.2759-.742-1.7659-.495-.4894-1.0811-.7342-1.7581-.7342z",
  fill: "#fff"
});

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 58 58",
    width: 58,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.34d0de69.svg";
export { ForwardRef as ReactComponent };